import {writable} from 'svelte/store';

const initState = {
    query: undefined,
    queryDisplay: undefined,

    isSearching: true,

    ridesData: [],
    ridesLoadedFromMap: true,

    availableFilters: [],
    selectedFilters: {
        rideTypes: null,
        levels: null,
        distance: null,
        duration: null
    },

    visibleRideIds: [],

    highlightedRideId: undefined
};

function SearchStore(state = initState) {
    const {
        subscribe,
        // set,
        update
    } = writable(
        state
    );

    function updateState(data) {
        Object.entries(data)
            .forEach(([dataName, newData]) => {
                update((storeState) => {
                    storeState[dataName] = newData;

                    return storeState;
                });
            });
    }

    return {
        subscribe,
        get state() {
            return state;
        },
        get query() {
            return state.query;
        },
        set query(query) {
            updateState({query});
        },
        get queryDisplay() {
            return state.queryDisplay;
        },
        set queryDisplay(queryDisplay) {
            updateState({queryDisplay});
        },
        get isSearching() {
            return state.isSearching;
        },
        set isSearching(isSearching) {
            updateState({isSearching});
        },
        get ridesData() {
            return state.ridesData;
        },
        set ridesData(ridesData) {
            if (ridesData) {
                updateState({ridesData});
                updateState({visibleMarkerIds: ridesData.map((ride) => ride.id)});
            } else {
                updateState({ridesData: []});
                updateState({visibleMarkerIds: []});
            }
        },
        get ridesLoadedFromMap() {
            return state.ridesLoadedFromMap;
        },
        set ridesLoadedFromMap(ridesLoadedFromMap) {
            updateState({ridesLoadedFromMap});
        },
        get availableFilters() {
            return state.availableFilters;
        },
        set availableFilters(availableFilters) {
            updateState({availableFilters});
        },
        get selectedFilters() {
            return state.selectedFilters;
        },
        set selectedFilters(selectedFilters) {
            updateState({selectedFilters});
        },
        get hasFilters() {
            if (!state.selectedFilters) {
                return false;
            }

            return Object.entries(state.selectedFilters)
                .some(([, filterValue]) => !!filterValue);
        },
        get visibleRideIds() {
            return state.visibleRideIds;
        },
        set visibleRideIds(visibleRideIds) {
            updateState({visibleRideIds});
        },
        get highlightedRideId() {
            return state.highlightedRideId;
        },
        set highlightedRideId(highlightedRideId) {
            updateState({highlightedRideId});
        }
    };
}

// export function getSearchState() {
//     return SearchStore().state || {};
// }

// export function CreateSearchStore(onStateUpdate) {
//     const store = SearchStore();
//
//     const unsubscribe = store.subscribe((newState) => {
//         if (typeof onStateUpdate === 'function') {
//             onStateUpdate(newState);
//         }
//     });
//
//     return {
//         store,
//         subscribe: store.subscribe,
//         unsubscribe
//     };
// }

export const searchStore = SearchStore();
